import Contract from "./Contract";

const Index = () => {

    
    return (
        <>
            <Contract title={"Due For Settlement"} settlementType={"2"}/>
        </>
    );
};

export default Index;
